/* import __COLOCATED_TEMPLATE__ from './fin-preview-url-builder.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';

interface Args {
  shareableFinToken?: string;
  customActionId?: string;
  demoType?: string;
  previewWorkflowId?: string;
}

interface Signature {
  Args: Args;
  Blocks: {
    default: [
      {
        messengerUrl: string;
      },
    ];
  };
  Element: HTMLElement;
}

export default class FinPreviewUrlBuilder extends Component<Signature> {
  @service declare appService: AppService;
  @service declare session: Session;

  get appId() {
    return this.appService.app.id;
  }

  get messengerUrl() {
    // Add `&local_client=true` to the end of the URL to see changes to intercom-js code in the preview.
    let iframeUrl = `${window.location.origin}/hosted_messenger/${this.appId}/fin_demo_preview?preview_only=true&intercom_disable_cookies=true`;

    if (this.args.shareableFinToken) {
      iframeUrl += `&source=shareablefinpreview&token=${this.args.shareableFinToken}`;
    }
    if (this.args.customActionId) {
      iframeUrl += `&custom_action_id=${this.args.customActionId}`;
    }
    if (this.args.demoType) {
      iframeUrl += `&demo_type=${this.args.demoType}`;
    }
    if (this.args.previewWorkflowId) {
      iframeUrl += `&preview_workflow_id=${this.args.previewWorkflowId}`;
    }

    return iframeUrl;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::Preview::FinPreviewUrlBuilder': typeof FinPreviewUrlBuilder;
    'workflows/preview/fin-preview-url-builder': typeof FinPreviewUrlBuilder;
  }
}
